<template>
  <div class="bg" v-show="show">
    <div  class="wrapper">
      <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      <iframe :src="r" class="iframes" align="absmiddle"></iframe>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
  name: "confirm",
  data() {
    return {
      show: true,
      r: "",
      t: "",
      type: {}
    };
  },
  methods: {
    async open(r,t) {
      if (!r) return;
      console.log("r", r, t);
      // this.r = r+'&platform='+encodeURIComponent(t);
      this.r = r+'&platform='+t;
      this.t = t;
      // const types = await this.getData()
      // this.matchTypes(types)
      this.show = true;
    },
    // matchTypes(types) {
    //   types.forEach((i, d) => {
    //     i.code = i.id
    //     this.types.forEach(j => {
    //       if (j.code == i.id) {
    //         this.$set(j, 'title', i.title)
    //       }
    //     })
    //   })

    //   this.type = types[0]
    // },
    selectType(t) {
      this.type = t;
    },
    close() {
      this.show = false;
    },
    confirm() {
      this.close();
      setTimeout(() => {
        this.r(`${this.type.code}`);
      }, 50);
    },
    cancel() {
      // this.r(false)
      this.close();
    },
    getData() {
      return common.myFetch(apis.Rpt_typelist, {}).then(r => {
        if (r) {
          return r.type;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1999;
  .wrapper {
    min-height: 520px;
    width: 616px;
    background-color: @bg;
    padding: 20px;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    position: relative;
    top: 23%; /*偏移*/
    z-index: 99998;
    margin: 0 auto;
    .iframes {
      height: 500px;
      width: 100%;
      border: none;
    }
    .close {
      position: absolute;
      right: -40px;
      top: -30px;
      cursor: pointer;
    }
  }
}
</style>
